/* Fietskoop Premium — kleine, uitstelbare verbeteringen (geen frameworks) */
(function () {
  'use strict';

  /* Scroll-reveal (respecteert reduced motion) */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.fk-reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.fk-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Toast */
  var toast;
  function showToast(msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'fk-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  function refreshCartUI() {
    /* Dawn: vernieuw cart-icon bubble via section rendering */
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-icon-bubble' : '/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-icon-bubble'];
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var target = document.getElementById('cart-icon-bubble');
        var fresh = holder.querySelector('.shopify-section') || holder.firstElementChild;
        if (target && fresh) target.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }

  /* Quick add (Maak je fiets compleet) */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-fk-quick-add]');
    if (!btn) return;
    ev.preventDefault();
    var id = btn.getAttribute('data-fk-quick-add');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    }).then(function () {
      btn.dataset.added = 'true';
      btn.innerHTML = '✓';
      btn.setAttribute('aria-label', 'Toegevoegd aan winkelwagen');
      showToast('Toegevoegd aan je winkelwagen');
      refreshCartUI();
      if (window.dataLayer) window.dataLayer.push({ event: 'fk_accessory_added', item_variant_id: id });
    }).catch(function () {
      showToast('Toevoegen is niet gelukt — probeer het opnieuw');
    }).finally(function () { btn.disabled = false; });
  });

  /* Analytics events (alleen dataLayer pushes, geen tracking zonder consent-laag) */
  if (window.dataLayer) {
    var pd = document.querySelector('[data-fk-product-handle]');
    if (pd) window.dataLayer.push({ event: 'fk_product_viewed', product_handle: pd.getAttribute('data-fk-product-handle') });
  }
})();

/* NL-labels voor standaardfilters (tijdelijk — hernoem ze definitief in de Search & Discovery app) */
(function () {
  var MAP = { 'Availability': 'Beschikbaarheid', 'Price': 'Prijs', 'In stock': 'Op voorraad', 'Out of stock': 'Uitverkocht' };
  function fix() {
    document.querySelectorAll('facet-filters-form span, facet-filters-form legend, facet-filters-form label, facet-filters-form summary, .active-facets__button-inner, .mobile-facets__label span').forEach(function (el) {
      if (el.children.length > 0) return;
      var t = el.textContent, s = t.trim(), out = t;
      Object.keys(MAP).forEach(function (k) {
        if (s === k || s.indexOf(k + ':') === 0 || s.indexOf(k + ' (') === 0) { out = out.replace(k, MAP[k]); }
      });
      if (out !== t) el.textContent = out;
    });
  }
  if (document.readyState !== 'loading') fix(); else document.addEventListener('DOMContentLoaded', fix);
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Eerlijke countdown — telt af naar een vaste einddatum, reset nooit */
(function () {
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-fk-countdown]').forEach(function (el) {
      var raw = el.getAttribute('data-end');
      if (!raw) return;
      var end = new Date(raw.indexOf('T') === -1 ? raw.replace(' ', 'T') : raw).getTime();
      if (isNaN(end)) return;
      var diff = end - now;
      if (diff <= 0) {
        el.classList.add('is-done');
        var d = el.querySelector('.fk-cd__done');
        if (d) d.hidden = false;
        return;
      }
      var s = Math.floor(diff / 1000);
      var set = function (sel, val) { var n = el.querySelector(sel); if (n) n.textContent = val; };
      set('[data-cd-d]', Math.floor(s / 86400));
      set('[data-cd-h]', pad(Math.floor(s % 86400 / 3600)));
      set('[data-cd-m]', pad(Math.floor(s % 3600 / 60)));
      set('[data-cd-s]', pad(s % 60));
    });
  }
  if (document.querySelector('[data-fk-countdown]')) { tick(); setInterval(tick, 1000); }
  else { document.addEventListener('DOMContentLoaded', function(){ tick(); setInterval(tick, 1000); }); }
})();

/* v3.2 — het verplaatsen van betaalicoontjes en uitklapblokken naar onder de galerij
   is bewust verwijderd. Die blokken horen in de rechterkolom; de galerij scrollt nu
   normaal mee (zie .product__media-wrapper in fk-deals.css). */
